/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Add_SlideInputs */

const vi_shop_home_add_slide = /** @type {(inputs: Shop_Home_Add_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm slide`)
};

/**

* @param {Shop_Home_Add_SlideInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_add_slide = /** @type {((inputs?: Shop_Home_Add_SlideInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Add_SlideInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_add_slide(inputs)
});